// カフェ訴求クリエイティブからの流入判定（DEV-3390のA/Bテスト → DEV-3574で恒久化）。
//
// ABテストではなく恒久的な出し分け（LPO）なので、cookieも乱数も持たない。
// URLだけで決まる純関数なので呼び出し側は初回レンダーで同期的に評価でき、
// 判定の確定を待たない＝フラッシュもレイアウトシフトも起きない。
//
// 旧実装（DEV-3390）はcookieの存在を参加印に兼用していたため、mcが落ちた再訪でも
// 同じパターンを出し続けていた。恒久反映ではこのstickyを意図的に捨てている
// （mc無しの再訪・リロードでは現行の帯FVに戻る）。来たクリエイティブに合ったFVを
// 出すのが恒久LPOとして素直なため。

// 対象パス。増やすときはこの配列だけ触る。
//
// 注意: この判定を使う InstagramAllRegionFormPage は foodslabo/job_seeker_controller の
// 8アクション＝14URLから描かれる（/instagram_asc, /instagram_organic, および
// /instagram-column_lp_{fukuoka,nagoya,sapporo,sendai,shizuoka,northern_kanto}/ の
// 6エリア×/sp/有無で12URL。/instagram_asc と /instagram_organic に /sp/ は無い）。
// パス条件を外すと14URL全部にカフェ訴求FVが出てしまう。
// DEV-3574時点の対象は /instagram_asc のみ（カフェクリエイティブの着地URLはここだけ、とPO確認済み）。
//
// 末尾スラッシュは重複も許している。Railsは /instagram_asc// も200で配信するため、
// 入稿URLの手組みでスラッシュが重なるとカフェFVだけ出ない、という事故を避けるため。
//
// 同じ /instagram_asc を対象にした定数が utils/genieeLinePromo/config.ts にもある。
// パス文字列は同じだが末尾スラッシュの扱いは異なり（あちらは \/?$ で1本まで）、
// /instagram_asc// ではこちらだけが一致する。対象パスを変えるときは両方を見ること。
const TARGET_PATH_PATTERNS: RegExp[] = [/^\/instagram_asc\/*$/]

// 広告のマーケティングコード（thanks/ThanksPage.tsx の SCOUT_MC_CODE と同じコード体系）。
// 11〜14文字目が '0010' ならカフェ訴求クリエイティブ（例 ?mc=16700000000010028300000）。
// 先頭10文字を \d で縛っているのは、空白や記号が頭に付いた値で桁がずれたまま
// 一致してしまうのを防ぐため。
// g フラグは付けないこと（lastIndex が残り test() の結果が交互に変わる）。
const MARKETING_CODE_PARAM = 'mc'
const MARKETING_CODE_PATTERN = /^\d{10}0010/

/**
 * カフェ訴求クリエイティブからの流入か。
 *
 * パス条件とマーケティングコード条件は合成した形でのみ公開している。別々に出すと
 * 呼び出し側がパス条件だけ落とせてしまい、上記14URLへの漏れ出しの入口になるため。
 */
export const isCafeCreativeInflow = (
    pathname: string,
    search: string
): boolean => {
    if (!TARGET_PATH_PATTERNS.some((pattern) => pattern.test(pathname))) {
        return false
    }

    const marketingCode = new URLSearchParams(search).get(MARKETING_CODE_PARAM)
    return marketingCode !== null && MARKETING_CODE_PATTERN.test(marketingCode)
}
